import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SearchSettingsModel, ToolbarItems, GridModule } from '@syncfusion/ej2-angular-grids';
import { Subscription } from 'rxjs';
import { ExportInterfaceMasterDataDTO, IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO } from 'src/app/base/models/models.swagger.generated';
import { GridLocalDataBaseComponent } from 'src/app/base/shared/grid-base/grid-local-data-base.component';
import { ExportConfigurationMasterDataServiceService } from 'src/app/domain/export-configuration/export-configuration-master-data.service';
import { ConfigurationFormCoordinatorService } from '../../../configuration-form-coordinator.service';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';

@Component({
    selector: 'app-configuration-form-file-filter-brand-sub',
    templateUrl: './configuration-form-file-filter-brand-sub.component.html',
    styleUrls: ['./configuration-form-file-filter-brand-sub.component.scss'],
    imports: [GridModule, QueryBuilderModule, ReactiveFormsModule, DropDownListModule, TranslateModule]
})

export class ConfigurationFormFileFilterBrandSubComponent extends GridLocalDataBaseComponent implements OnInit, OnDestroy {

  @Input() // Already selected filters
  public set brandSubBrandFilter(value: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[]) {
    this.assignedBrandSubBrandFilters = value;
    this.data = value;
  }

  @Input() // header text
  public title: string;

  @Output() // transfer the selected filters back to parent
  public gridDataChanged = new EventEmitter<IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[]>();

  public toolbar: ToolbarItems[] = ['Add'];
  public brandSubBrands: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] = [];
  public subBrands: string[];

  private _brands = [];
  private assignedBrandSubBrandFilters: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[];
  private subscription: Subscription;

  constructor(private configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private masterDataServiceService: ExportConfigurationMasterDataServiceService,
    translateService: TranslateService,
    private fb: UntypedFormBuilder,
  ) {
    super(null, translateService, null);
    this.searchOptions = { fields: ['brandSubBrands', 'subBrands'] };
  }

  ngOnInit() {
    this.subscription = this.configurationFormCoordinatorService.configurationDetailsDTOUpdated.subscribe(data => {
      this.initData();
      this.grid.refresh();
    })
    this.initData();
  }

  public get brands(): string[] {
    return this._brands;
  }

  public brandChange(event) {
    this.initSubbrands(event.value);
  }

  protected initializeEditForm(data: any): void {
    this._brands = this.brandSubBrands.map(item => item.filterBrand)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.initSubbrands(data.filterBrand);

    this.gridEditForm = this.fb.group({
      filterBrand: [data.filterBrand],
      filterSubBrand: [data.filterSubBrand],
    });
  }

  protected getEditDialogTitleParams(rowData: any): object {
    return { param: rowData.brand };
  }

  protected override getDataToSave(data: any): any {
    const dat = data as IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO;
    dat.filterBrand = this.gridEditForm.value.filterBrand ?? ""; // this is required, otherwise we cannot delete the record when brand is empty
    dat.filterSubBrand = this.gridEditForm.value.filterSubBrand;
  }

  protected override dataSaveCompleteAction(args: any) {
    if (args.action === 'edit') {
      if (args.rowIndex >= 0 && this.assignedBrandSubBrandFilters?.length > args.rowIndex) {
        this.assignedBrandSubBrandFilters[args.rowIndex] = args.data;
        this.grid.refresh();
        this.gridDataChanged.emit(this.data);
      }
    }
    else if (args.action == 'add') {
      this.gridDataChanged.emit(this.data);
    }
  }

  private initSubbrands(brand: string) {
    if (brand?.length > 0) {
      this.subBrands = this.brandSubBrands.filter((item) => item.filterBrand == brand)
        .map((item) => item.filterSubBrand)
        .filter((value, index, self) => self.indexOf(value) === index);
    } else {
      this.subBrands = this.brandSubBrands.map((item) => item.filterSubBrand)
        .sort()
        .filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  private initData() {
    this.data = this.assignedBrandSubBrandFilters;
    this.editDialogTitle = 'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.add-dialog-title';
    this.editSettings = { ...this.editSettings, showDeleteConfirmDialog: false };
    this.masterDataServiceService.getMasterDataForFileName().subscribe((masterData: ExportInterfaceMasterDataDTO) => {
      this.brandSubBrands = masterData.brandSubBrands.map((data) => {
        return { filterBrand: data.brandCode, filterSubBrand: data.brandSubCode };
      });
    });
    this.cssClass = "exception-filter-dialog";
    this.grid?.refresh();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
